import React, { useState, useEffect, useRef, useCallback } from "react";
import DynamicTable from "../../components/admin/Table";
import NoSubscription from "../../components/user/NoSubscription";
import ErrorModal from "../../components/UI/Modal";
import Spinner from "../../components/UI/Spinner";
import { musicService } from "../../services";

const AllMusic = () => {
  // Table data and pagination state.
  const [tableData, setTableData] = useState([]);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [pageLoading, setPageLoading] = useState(true);
  const [error, setError] = useState(false);
  const [errorMessage, setErrorMessage]=useState("");
const columns = ['title', 'earnings', 'streams'];
  const fetchData = async (pageNumber) => {
    setError(false)
    setLoading(true);
    try {
        let allMusic=await musicService.myMusic()
allMusic=allMusic.map(music=>{
let myMusic={...music, earnings:music.totalEarnings, streams: music.totalStreams}
return myMusic
})
      setTableData(allMusic);

      //   if (newData.length === 0) {
      //     setHasMore(false);
      //   } else {
      //     setTableData((prev) => [...prev, ...newData]);
      //   }
    } catch (error) {
      setError(true)
      setErrorMessage(error.message)
    }finally{
      setPageLoading(false)
    }
    setLoading(false);
  };

  // Load initial data on component mount.
  useEffect(() => {
    fetchData(page);
  }, []);

  // Set up the Intersection Observer to detect when the last row is visible.
  const observer = useRef();
  const lastRowRef = useCallback(
    // (node) => {
    //   if (loading) return;
    //   if (observer.current) observer.current.disconnect();

    //   observer.current = new IntersectionObserver((entries) => {
    //     if (entries[0].isIntersecting && hasMore) {

    //       const nextPage = page + 1;
    //       setPage(nextPage);
    //       fetchData(nextPage);
    //     }
    //   });
    //   if (node) observer.current.observe(node);
    // },
    [loading, hasMore, page]
  );
  const tableTitle =  "All Music";
  const actionsMenu={
    pageEdit:true,
    edit:false,
    delete:true,
    customEditLink:'/user/my-music/edit/',
    customViewLink:'/user/my-music/'
  }

  if(error) return <ErrorModal isOpen={error} onClose={()=>setError(false)} title={"Error Getting Music"} message={`${errorMessage || "There is error while trying to fetch all music. Please check your internet contivities and refresh this page to try again"}`} />;
  return (
    <>
      {pageLoading ? (
      <div className="grid place-items-center min-h-[100vh]">  <Spinner /> </div>
      ) : (
        <div className="bg-gray-100 p-4  h-full mix-blend-multiply min-h-[100vh]">
          <h1 className="text-xl capitalize font-bold mb-4">{tableTitle}</h1>
          <div className="overflow-x-auto">
            {tableData?.length>0?
            <DynamicTable
            columns={columns}
            data={tableData}
            url={"-music"}
            actionsMenu={actionsMenu}
            //   lastRowRef={lastRowRef}
          />:<NoSubscription title={"No Music Yet"} message={"You have not upload any music yet . Upload music today to enjoy unlimited benefit and get your music across audience around the world"} buttonText={"Upload Here"} url={"/user/upload-music"}/>}
          </div>
          {loading && (
            <div className="flex justify-center mt-4">
              <div
                className="w-8 h-8 border-4 border-blue-500 border-dotted rounded-full animate-spin"
                role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          )}
          {!hasMore && (
            <div className="text-center text-gray-500 mt-4">
              No more data to load.
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default AllMusic;